import styled from 'styled-components';

export const TabNav = styled.nav`
	z-index: 999;
	position: fixed;
	bottom: 1rem;
	left: 0.5rem;
	right: 0.5rem;
	display: flex;
	gap: 6px;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding: 11px;
	border-radius: 50px;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
	background-color: #257226;
`;

export const Tab = styled.div`
	width: 25%;
	text-align: center;
	width: 25%;
	height: 44px;
	border-radius: 50px;
	border: 1px solid #414d2a;
	overflow: hidden;
	a {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		transition: background-color 0.25s ease-in-out;
		&.active {
			background-color: #1c4220;
		}

		svg path {
			fill: #fff;
		}
	}
`;
